import { preciseAddSubtract } from 'utils/roundToFix';
import { BetType } from '../types';

export const getBetSum = (bets: BetType): number =>
  Object.values(bets).reduce<number>((sum, value) => preciseAddSubtract(sum, value, 'add'), 0);
